import React from "react";
import "./ACMarksCentrePanel.css";
import { handleDownload, handleDownloadStage3, getQualificationTitle, getCenterType, checkunitIsConsortiaUnit } from "../../utils/utils";
import { useLocation, useNavigate } from "react-router-dom";
import { useCenter } from "../../context/CenterContext";
import { useApi } from "../../context/ApiClient";
import { useModerationWindowSession } from "../../constants/Constants";
import { useSubject } from "../../context/SubjectContext";
import { useUnits } from "../../context/UnitsContext";
import { useConsortiaCenter } from "../../context/ConsortiaCenterContext";

const AssessmentCriteriaHeader = ({
  selectedSubjectCode,
  selectedSubject,
  visitDate,
  sessionId,
  sessionStartDate,
  sessionEndDate,
  unit,
  mode,
  onSave,
  submissionPayload,
  downloadPayload = [],
  subjectData,
  selectedCandidate,
  candidateDataMap,
  onSubmit,
  allCandidatesCompleted,
  missingOrInvalidCandidates,
  assessmentCandidateData,
  achievedCount,
  totalCriteria,
  candidateMarks,
  totalMarks,
  isStage3 = false,
  isPostStage3 = false,
  additionalVisitDate = null,
  currentSection,
  originalsSubmitted,
  updatedSubmitted,
}) => {
  const location = useLocation();
  const { consortiaCentres } = useConsortiaCenter();
  const { consortiaUnits } = useUnits();
  const { centerName, centerNumber ,centres} = useCenter() || {};
  const moderationWindowSession = useModerationWindowSession();
  const { markStatus, totalMarkStatus } = location.state || {};
  const baseUrl = process.env.REACT_APP_AMS_BASE_URL;
  const consortiaUnitcode =
    String(unit ?? "")
      .toUpperCase()
      .match(/^[A-Z0-9]+/)?.[0] || "";
  const isConsortiaUnit = checkunitIsConsortiaUnit(
    consortiaCentres,
    centerNumber,
    sessionId,
    consortiaUnitcode,
  );
  const { subjects } = useSubject();

  const currentCentreType = getCenterType(consortiaCentres, Number(centerNumber), subjectData?.selectedSubject, subjectData?.selectedSubjectId) || '';

  const api = useApi((currentCentreType === 'Lead' && isConsortiaUnit) ? `${baseUrl}consortia/` : baseUrl);

  const navigate = useNavigate();
  const isSubmitDisabled =
    !allCandidatesCompleted ||
    (currentSection === "originalMarks" && !!originalsSubmitted) ||
    (currentSection === "updatedMarks" && !!updatedSubmitted);

    const isSaveDisabled = (currentSection === "originalMarks" && !!originalsSubmitted)
  const getSessionDetails = (visits) => {
    const academicYear = `${new Date(
      visits.sessionStartDate
    ).getFullYear()}/${String(
      new Date(visits.sessionEndDate).getFullYear()
    ).slice(-2)}`;
    return visits.sessionId === moderationWindowSession.window1
      ? `Window 1 (February series) - ${academicYear}`
      : visits.sessionId === moderationWindowSession.window2
        ? `Window 2 (June series) - ${academicYear}`
        : "";
  };
  const formatDate = (dateStr) => {
    if (!dateStr) return ""; // or return "N/A", depending on what you want

    const date = new Date(dateStr);
    if (isNaN(date)) return ""; // handle invalid date strings

    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };
  const handleBack = () => {
    navigate(-1);
  };
  return (
    <div className="xcontainer" style={{ backgroundColor: "#FFFFFF" }}>
      <section className="section mt-0 py-0 pr-4" style={{ padding: "3rem" }}>
        <div className="pt-3 subject-header-fixed xhas-shadow-2">
          <div className="column pl-0 pb-0">
            <p className="is-size-6 has-text-weight-bold">
              {getQualificationTitle(subjects, subjectData?.selectedSubjectId)}
            </p>
            <h1 className="title mb-1 mt-1" style={{ fontSize: "24px" }}>
              {selectedSubject || "Subject Name"}{" "}
              <span className="is-size-6 has-text-weight-normal">
                {selectedSubjectCode}
              </span>
            </h1>

            <p className="xbox xnotification is-info mt-0">
              {isStage3 ? 'Enter and submit assessment criteria marks for the additional candidates sampled.' : 'Enter and submit assessment criteria marks for sample candidates'}
            </p>
          </div>

          <hr className="my-2" />

          <div
            className="xcard xunit-header xp-4 is-flex is-justify-content-space-between mb-0 is-align-items-center"
            style={{ backgroundColor: "#FFFFFF" }}
          >
            <div>
              <div className="is-size-6">
                <strong>Visit date: {formatDate(visitDate)}</strong> |
                {getSessionDetails({
                  sessionStartDate,
                  sessionEndDate,
                  sessionId,
                })}
              </div>
              {additionalVisitDate && (
                <div className="is-flex is-align-items-center">
                  <span className="icon mr-1">
                    <svg
                      style={{ fill: "#a55900" }}
                      xmlns="http://www.w3.org/2000/svg"
                      height="24px"
                      viewBox="0 -960 960 960"
                      width="24px"
                      fill="212121"
                      aria-hidden="true"
                      focusable="false"
                    >
                      <path d="m560-120-57-57 144-143H200v-480h80v400h367L503-544l56-57 241 241-240 240Z" />
                    </svg>
                  </span>
                  <span className="pt-1">
                    <strong style={{ color: "#a55900" }}>
                      {`Additional visit: ${formatDate(additionalVisitDate)}`}
                    </strong>
                  </span>
                </div>
              )}
              <div className="is-size-5">
                <strong>{unit}</strong>
              </div>
            </div>

            <div>
              <div className="field is-grouped">
                {mode === "view" && (
                  <div className="control mr-2 mb-0 mt-3">
                    <div className="tags has-addons">
                      <span className="tag is-success submit-color">
                        {isStage3 ? "✔ Updated criteria marks submitted" : "✔ Criteria marks submitted"}
                      </span>
                    </div>
                  </div>
                )}
                <button
                  className=" button is-text is-outlined mr-2 btn-w-back"
                  onClick={handleBack}
                >
                  <span className="icon mr-2">
                    <svg
                      style={{ fill: "#0076BD" }}
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 -960 960 960"
                      width="24"
                      aria-hidden="true"
                      focusable="false"
                    >
                      <path d="M560-253.847 333.847-480 560-706.153 602.153-664l-184 184 184 184L560-253.847Z" />
                    </svg>
                  </span>
                  Back
                </button>
                {mode === "edit" && (
                  <>
                    <button
                      className=" button is-primary is-outlined mr-2 btn-w-save"
                      onClick={() => onSave && onSave(submissionPayload)}
                      disabled={isSaveDisabled}
                    >
                      Save
                    </button>
                  </>
                )}
                {
                 (currentCentreType === 'Rest' && mode === 'view' && isConsortiaUnit) ? <></> :
              
                <button
                  className="button is-primary is-outlined mr-2 btn-w-dld"
                  onClick={async () => {
                    if (!isStage3) {
                      try {
                        if (mode === "edit" && onSave) {
                          // Await the save API before continuing
                          await onSave(submissionPayload, "downloadSave");
                        }

                        // Only trigger download after save completes
                        await handleDownload(
                          submissionPayload,
                          "criteriaMarks",
                          location,
                          { centerName, centerNumber },
                          subjectData,
                          api,
                          { selectedCandidate, mode, candidateDataMap },
                          currentCentreType,
                         isConsortiaUnit ,centres, moderationWindowSession
                        );

                        
                      } catch (err) {
                        console.error("Error during save or download", err);
                      }
                    } else {
                      try {
                        if (mode === "edit" && onSave && (!(currentSection === "originalMarks" && !!originalsSubmitted))) {
                          // Await the save API before continuing
                          await onSave(submissionPayload, "downloadSave");
                        }

                        // Only trigger download after save completes
                        await handleDownloadStage3(
                          currentSection === "originalMarks" ? downloadPayload.original.marks : downloadPayload.updated.marks,
                          "criteriaStage3Marks",
                          location,

                          { centerNumber, centerName },
                          subjectData,
                          api,
                          { selectedCandidate, mode, candidateDataMap },
                           isPostStage3,
                      currentCentreType,
                      isConsortiaUnit,
                      centres,
                      isStage3,
                      moderationWindowSession
                        )
                      } catch (err) {
                        console.error("Error during save or download", err);
                      }
                    }

                  }}
                >
                  Download
                </button>
}
                {mode === "edit" && (
                  <>
                    <button
                      className="button is-primary btn-w-submit"
                      onClick={(e) => {
                        e.currentTarget.blur();
                        onSubmit && onSubmit(submissionPayload);
                      }}
                      disabled={isSubmitDisabled}
                      aria-disabled={!allCandidatesCompleted}
                    >
                      Submit marks
                    </button>
                  </>
                )}
                {/*
                    <button className="button is-success js-modal-trigger" id="btnSubmitWindowPopup" data-target="modal-js-submit" style={{ position: "absolute", left: "-10000px" }}>
                      Submit marks
                    </button>
                    */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
export default AssessmentCriteriaHeader;
